export default __webpack_public_path__ + "static/assets/cc45e6848f42e3800047c2599c7db1ec.png";